@use 'tokens.module' as t;

.embed {
  height: 0;
  overflow: hidden;
  position: relative;
  width: 100%;

  iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  :global(.image.is-background) {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}

.embed16by9 {
  padding-bottom: 56.25%;
}

// Like .embed, but sized via aspect-ratio (set inline from the video's ratio)
// instead of the padding-bottom trick, so the height can be capped for portrait videos
.embed-fit {
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  width: 100%;

  iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  :global(.image.is-background) {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}

.hidden {
  display: none !important;
}

.play-button {
  color: t.$white;
  cursor: pointer;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}
